<!-- list -->
<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'ATTRIBUTES.LIST_OF_GROUP_ATTRIBUTES' | translate }}</div>
                <div class="tools">

                    <div class="form-wrapper">
                        <form class="form" [formGroup]="form" autocomplete="off">
                            <div class="">
                                <input formControlName="search" class="form-control serch-form" type="text"
                                    placeholder="{{ 'SEARCH' | translate }}" aria-label="Search">
                            </div>
                        </form>
                    </div>

                    <!-- <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button> -->

                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>

                </div>
            </div>

            <!-- <div class="row">

                <div class="col-12">

                 <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                     <input formControlName="search" class="form-control" type="text" placeholder="{{ 'SEARCH' | translate }}Поиск" aria-label="Search">

                   </form>
                   
                </div>
             </div> -->

            <div class="card-body">

                <table class="table table-hover">

                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_group_all"
                                        id="select_attr_group_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_attr_group_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name">{{ 'NAME' | translate }}</th>
                            <th scope="col" class="action"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="groupsList && groupsList.length > 0">
                        <tr *ngFor="let group of groupsList; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_group_all{{ i }}"
                                        id="select_attr_group_all{{ i }}" [checked]="group.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_attr_group_all{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{group.name}}</td>
                            <td class="action">
                                <div class="action-btn">
                                    <button type="button" class="btn btn-none" (click)="onEdit(group.id)" placement="left" tooltipClass="clue-name" ngbTooltip="{{ 'EDIT' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/edit.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <button type="button" class="btn btn-none" (click)="onDelete(group.id)"  placement="left"  tooltipClass="clue-name" ngbTooltip="{{ 'DELETE' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/delete.svg" [stretch]="true"[svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <!-- <section class="action-btn_list">
        
                                        <ng-template class="btn-list" #popContent>
    
                                            <div class="btn-list_item"
                                                (click)="onEdit(role.urole.id)">
                                                <span>{{ 'Редактировать' | translate }}</span>
                                            </div>
    
                                            <div class="list-item_delete"
                                                (click)="deleteOneRole(role.urole.id)">
                                                <span>{{ 'Удалить' | translate }}</span>
                                            </div>
    
                                        </ng-template>
    
                                        <button type="button" placement="left" [ngbPopover]="popContent"
                                            [autoClose]="true" triggers="manual" #p="ngbPopover"
                                            class="btn btn-none action-btn_active btn-sm"
                                            popoverClass="my-custom-class"
                                            (click)="openWindowWithButton(p)"
                                            ngbTooltip="Действия">
                                            <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                        </button>
                                    </section> -->
    
                                </div>
                                    
                            </td>
                            <!-- <td class="action">

                                btn edit
                                <button type="button" class="btn btn-light" (click)="onEdit(group.id)"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>

                                btn delete
                                <button type="button" class="btn btn-light" (click)="onDelete(group.id)"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td> -->
                        </tr>
                    </tbody>

                    <tbody *ngIf="!groupsList || groupsList.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="2">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="2">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>